.Embed {
  width: 100%;
  height: 100%;
  border: none;
}